












require("axios");
import { Component, Prop, Vue } from "vue-property-decorator";
import NewApi, { BasePath, ImagePath, ImageThumbPath } from "../ts/api";
import { DefaultApi, Image, Credentials, Gallery as GalleryComp } from "../api";

import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

let api: DefaultApi;

const GalleryProps = Vue.extend({
  props: {
    id: Number,
  }
});

@Component({
  components: {
    CoolLightBox
  }
})
export default class Gallery extends GalleryProps {
  gallery = {} as GalleryComp;
  lbData = [] as any
  index = -1
  mounted() {
    api = NewApi();
    let ctx = this
      api.galleryIdGet(this.id).then(function(r){
        ctx.gallery = r.data
        ctx.gallery.images = ctx.gallery.images.sort((a,b)=> a.order - b.order)
      ctx.prepareLightbox(ctx.gallery.images)
    });
    
  }

  prepareLightbox(images :Image[]){
    console.log("prepare lightbox")
    let lbData = []
    for(let i in images){
      let lbImg = {
        src:  this.getImageUrl(this.gallery.images[i].filename),
      }
      lbData.push(lbImg)
    }
    this.lbData = lbData
    console.log("prepared: " + lbData.length + "/" + images.length)
  }

  getImageUrl(filename?: string) {
    if(filename != null){
      return ImagePath(filename)
    }
  }

  getImageThumbUrl(filename?: string){
    if(filename != null){
      return ImageThumbPath(filename)
    }
  }
}
